import React from 'react';

const Programme = () => {
  return (
    <section id="programme" className="py-12 px-6 bg-secondary text-primary">
      <div className="max-w-6xl mx-auto">
        <h3 className="text-3xl font-bold mb-6">Programme</h3>
        <ul className="list-disc list-inside space-y-4">
          <li>Learn Spanish alongside other subjects, fostering tolerance, curiosity, and cognitive benefits.</li>
          <li>Montessori/British curriculum encourages a love for learning and independence.</li>
          <li>After-school care with trusted/trained nannies, refreshments, and rest while waiting for parents.</li>
          <li>Safe, transparent environment with CCTV access for parents.</li>
          <li>Skill acquisition for learners to develop proficiency in various areas.</li>
        </ul>
      </div>
    </section>
  );
};

export default Programme;



